<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em;">Dr. Sofia Costa is an author, artist and reiki master with a doctorate in physical therapy. In 2020, she self-published her first book, <em>The End of Back Pain: The Secret to Gaining Relief and Staying Active</em>.</p><br/>
<p style="text-indent:00em;">Dr. Sofia was born in Puerto Rico to a family of artists, healers, shamans and medicine men and women, allowing her to gain access to ancient wisdom and spiritual practices that amplify Heart-Earth connection. She integrates the art of alchemical medicine through movement, breathwork, sound meditation, energy healing, and handcrafted creations.</p><br/>
<p style="text-indent:00em;">Dr. Sofia’s passion is guiding people on a heart-centred journey to alchemize fears, integrate a new way of being, and embody the power of who they are so they can strengthen their connection to Self, Earth, Lineage and Love.</p><br/>
<p style="text-indent:00em;">To live wholeheartedly is Dr. Sofia’s intention.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?52c90fce